// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2LcQF","footer":"ReportModalFilter_footer___LQ9k"};